import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { ContratoService } from '../../../../../providers/contrato-service';
import { AlertService } from '../../../../../providers/alert-service';
import { MenuService } from '../../../../../providers/menu-service';
import { ModulosController } from '../../../modulos-controller';
import { UsuarioService } from '../../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../../providers/gestao-pca-service';

@Component({
  selector: 'page-registro-despesas-sem-contrato-desacordo-art62',
  templateUrl: 'registro-despesas-sem-contrato-desacordo-art62.html',
  providers: [
    ContratoService
  ]
})
export class RegistroDespesasSemContratoDesacordoArt62Page extends ModulosController {
  listaDados: any;
  loading: boolean = true;
  submetendoNoCertificado: boolean = false;
  idSecaoPagina: string = "54";
  page1: number = 1;

  order: string = 'credor';
  reverse: boolean = true;

  constructor(public navCtrl: NavController,
    public alertService: AlertService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    public navParams: NavParams,
    public contratoService: ContratoService,
    public gestaoPcaService: GestaoPcaService,
    private menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
    this.carregarDados();

    this.setModuloId(5);
    this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = false;
      this.order = "-" + value;
    } else {
      this.reverse = true;
      this.order = value;
    }
  }

  carregarDados() {
    this.contratoService.obterDadosNotasSemContrato().subscribe(data => {
      this.listaDados = data;
      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
    });
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  formatarPorcentagem(valor) {
    return valor.toString().replace('.', ',') + "%";
  }

  voltar() {
    this.menuService.redirecionarPagina(this.contratoService.obterIdPaginaContrato());
  }

  salvarComentario(enviarMensagem = true) {
    this.loading = true;
    if (this.listaDados) {
      this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);
      this.contratoService.salvarDadosNotasSemContrato(this.listaDados, this.idSecaoPagina).subscribe(data => {

        if (enviarMensagem) {
          this.alertService.mostraAlerta("", "Salvo com sucesso.");
        }
        this.loading = false;
      }, error => {
        if (enviarMensagem) {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
        }
        this.loading = false;
      });
    }
  }

  submeterNoCertificado() {
    this.loading = true;
    if (this.listaDados.resultadoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.resultadoAnalise == null || this.listaDados.resultadoAnalise == undefined || !this.listaDados.resultadoAnalise) {
      this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
      this.loading = false;
    } else {
      if (this.listaDados) {
        this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);
        this.contratoService.finalizarNotasSemContrato(this.listaDados, this.idSecaoPagina).subscribe(data => {
          this.alertService.mostraAlerta("", "Submetido com sucesso.");
          this.voltar();
        }, error => {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
          this.loading = false;
        });
      }
    }
  }

  capitalize(str) {
    let retorno = "";

    if (str) {
      retorno = str.charAt(0).toUpperCase() + str.slice(1);
    }

    return retorno;
  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/contratos/contrato-analise/registro-despesas-sem-contrato-desacordo-art62/registro-despesas-sem-contrato-desacordo-art62.ts